const hubliDoc = [
  {
    button: "Sights & Landmarks",
    places: [
      {
        name: "Agadi Thota",
        link:
          "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0d/6b/5d/a4/lunch.jpg?w=300&h=300&s=1",
        rating: "4.1/5"
      },
      {
        name: "Nrupatunga Betta",
        link:
          "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/05/2b/ee/b7/playing-area-for-kids.jpg?w=300&h=300&s=1",
        rating: "4.5/5"
      },
      {
        name:"Shri Siddharoodha Swamy Math",
        link:"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/0d/ed/c6/ae/shri-siddharoodha-swami.jpg?w=500&h=-1&s=1",
        rating:"4.9/5",
      },
      {
        name:"Nuggikeri",
        link:"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/1a/25/21/e6/nuggikeri.jpg?w=600&h=-1&s=1",
        rating:"4.9/5",
      },{
        name:"Kittur Rani Channamma Circle",
        link:"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/1a/11/9a/f5/caption.jpg?w=600&h=-1&s=1",
        rating:"4/5",
      }
    ]
  },
  {
    button: "Park",
    places: [
      {
        name: "Unakal Lake",
        link:
          "https://dynamic-media-cdn.tripadvisor.com/media/photo-o/04/50/ad/d8/unakal-lake.jpg?w=300&h=300&s=1",
        rating: "4/5"
      },
      {
        name:"Utsav Rock Garden",
        link:"https://dynamic-media-cdn.tripadvisor.com/media/photo-o/18/c2/d8/21/dr-rajkumar-circle-the.jpg?w=600&h=400&s=1",
        rating:"4.3/5",
      },
    ]
  },
  {
    button:"Dam",
    places:[
      {
        name:"Neerasagar Dam",
        link:"https://i.ytimg.com/vi/fNTymyy-KmU/0.jpg",
        rating:"4.9/5"
      }
    ]
  }
];
export default hubliDoc;
